import styled from 'styled-components';
import { AutoComplete } from 'antd';

export const StyledAutoComplete = styled(AutoComplete)`
  .ant-select-selector {
    .ant-select-selection-wrap {
      .ant-select-selection-search {
        .ant-select-selection-search-input {
          height: unset;
        }
      }
    }
  }
`;
